import { render, staticRenderFns } from "./UserInterface.vue?vue&type=template&id=c8a673a4&"
import script from "./UserInterface.vue?vue&type=script&lang=js&"
export * from "./UserInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports